import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    Fab,
    IconButton,
    Radio,
    TextField,
    Typography,
    withStyles
} from '@material-ui/core';
import { Add, Close } from '@material-ui/icons';
import { Autocomplete } from "../../../apis/google_places/components";
import APIService from "../../../apis/amplify/APIService";
import {
    push_address,
    receive_appointment_address,
    receive_user_addresses,
    receive_zip_codes,
    remove_address
} from "../../../apis/redux/fetchActions";
import DialogTitleContainer, { Title, TitleButton } from "../../../components/DialogTitleContainer";
import SectionTitleContainer, { SectionRight, SectionTitle } from "../../../components/SectionTitleContainer";
import Adaptable from "../../../components/Adaptable";
import If from "../../../components/If";
import Notification, { NActionButton, SUCCESS_TYPE } from "../../../components/Notification";
import Loading, { LoadingText, Progress } from "../../../components/Loading";
import { errorBundaryHOC } from "../../../components/ErrorBoundary";
import { styles } from "./styles";

const loadingMsg = 'Loading address...';

class AddressStep extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            loadingText: '',
            addAddressDialogOpen: false,
            pendingAddAddress: undefined,
            selectedAddress: null,
            snackBarText: '',
            snackBarOpen: false,
            notifySuccess: true,
            adding: false,
            currentZipCode: ''
        }
    }

    componentDidMount() {
        this.setState({ loading: true, loadingText: loadingMsg });
        if (this.props.zipCodes.length === 0)
            APIService.getAllowedZipCodes()
                .then(response => {
                    this.props.actions.receiveZipCodes(response);
                })
                .catch(console.error);
        if (this.props.addresses.length === 0)
            APIService.getAddressList()
                .then(response => {
                    if (response.length === 1) {
                        this.setState({ selectedAddress: response[0] });
                        this.props.actions.receiveAppointmentAddress(response[0]);
                    }
                    this.props.actions.receiveUserAddresses(response);
                })
                .catch(console.error)
                .finally(() => {
                    this.setState({ loading: false, loadingText: '' });
                });
        else
            this.setState({ loading: false, });

        if (this.props.appointmentData.appointment_address !== null)
            this.setState({ selectedAddress: this.props.appointmentData.appointment_address });
    }


    addAddress() {
        this.setState({ adding: true });
        document.getElementById('saveProgress').style.display = 'inline';
        const title = document.getElementById('addressTitle') !== undefined ? document.getElementById('addressTitle').value : '';
        const address = this.state.pendingAddAddress;
        let addressFormatted = {
            title: title,
            address: {
                address_line1: address.address,
                address_line2: '',
                postal_code: address.zipCode,
                locality: address.county,
                administrative_area: address.stateShort,
                country_code: address.countryShort,
            }
        };
        APIService.geoCodeAddress(addressFormatted.address)
            .then(response => {
                APIService.registerAddress(addressFormatted, response.coordinates)
                    .then(response => {
                        let finishStep = Object.assign({
                            id: response.id
                        }, addressFormatted);
                        this.props.actions.pushAddress(finishStep);
                        this.setState({selectedAddress: response});
                        this.setState({
                            snackBarText: 'Address added successfully.',
                            snackBarOpen: true,
                            notifySuccess: true
                        });
                    })
                    .catch(() => {
                        this.setState({
                            snackBarText: 'An error has occurred when you add the address.',
                            snackBarOpen: true,
                            notifySuccess: false
                        });
                    })
                    .finally(() => {
                        this.setState({ addAddressDialogOpen: false });
                        document.getElementById('saveProgress').style.display = 'none';
                        this.setState({ adding: false });
                    })
            })
            .catch(() => {
                this.setState({
                    snackBarText: 'An error has occurred when you add the address.',
                    snackBarOpen: true,
                    notifySuccess: false
                });
                this.setState({ adding: false });
            })
    }

    isChecked(address) {
        if (this.state.selectedAddress === null)
            return false;
        else
            return this.state.selectedAddress.id === address.id;
    }

    check(address) {
        this.props.actions.receiveAppointmentAddress(address);
        this.setState({ selectedAddress: address });
    }

    useOnce() {
        this.setState({ adding: true });
        if (this.state.pendingAddAddress !== undefined) {
            document.getElementById('useOnceProgress').style.display = 'inline';
            const address = this.state.pendingAddAddress;
            let addressFormatted = {
                id: -Date.now(),
                address: {
                    address_line1: address.address,
                    address_line2: '',
                    postal_code: address.zipCode,
                    locality: address.county,
                    administrative_area: address.stateShort,
                    country_code: address.countryShort,
                }
            };
            APIService.geoCodeAddress(addressFormatted.address)
                .then(response => {
                    Object.assign({
                        location: response.coordinates
                    }, addressFormatted);
                })
                .catch(console.error);
            this.props.actions.pushAddress(addressFormatted);
            this.setState({addAddressDialogOpen: false, selectedAddress: addressFormatted});
            document.getElementById('useOnceProgress').style.display = 'none';
            this.setState({adding: true});
        }
    }

    addPendingAddress(parsed) {
        if (parsed.address !== undefined) {
            if (this.props.zipCodes.filter(code => code === parsed.zipCode).length === 0) {
                document.getElementById('zipCodeError').style.visibility = 'visible';
                this.setState({ currentZipCode: parsed.zipCode, pendingAddAddress: undefined });
            } else {
                document.getElementById('zipCodeError').style.visibility = 'hidden';
                this.setState({ pendingAddAddress: parsed });
            }
        }
    }

    onDelete(addressId, event) {
        event.stopPropagation();
        if (addressId !== undefined && addressId !== null) {
            if (addressId < 0) {
                this.props.actions.removeAddress(addressId);
                this.setState({
                    snackBarText: 'Address deleted successfully .',
                    snackBarOpen: true,
                    notifySuccess: true
                });
            }
            else {
                this.setState({ loadingText: 'Deleting address...', loading: true });
                APIService.deleteAddress(addressId)
                    .then(response => {
                        if (response.success === true) {
                            this.setState({
                                snackBarText: 'Address deleted successfully.',
                                snackBarOpen: true,
                                notifySuccess: true
                            });
                            this.loadAddress(true)
                        }
                        else
                            this.setState({
                                snackBarText: 'There has been an error.',
                                snackBarOpen: true,
                                notifySuccess: false
                            });
                    })
                    .catch((error) => {
                        if (error) {
                            this.setState({
                                snackBarText: 'There has been an error. Check your connection and try again.',
                                snackBarOpen: true,
                                notifySuccess: false
                            });
                        }
                    })
                    .finally(() => {
                        this.setState({ loadingText: '', loading: false });
                    })
            }
            const {selectedAddress} = this.state;
            if (selectedAddress && addressId === selectedAddress.id) {
                this.props.actions.receiveAppointmentAddress(null);
                this.setState({selectedAddress: null});
            }

        }
    }

    render() {
        const { classes } = this.props;
        return (
            <div>

                <Dialog open={this.state.addAddressDialogOpen}
                        disableBackdropClick={false}
                        PaperProps={{ className: classes.modalDialog }}
                        onBackdropClick={() => this.setState({ addAddressDialogOpen: false })}>
                    <DialogTitleContainer>
                        <Title>NEW ADDRESS</Title>
                        <TitleButton location="right"
                                     onClick={() => this.setState({ addAddressDialogOpen: false })}>
                            <Close/>
                        </TitleButton>
                    </DialogTitleContainer>
                    <DialogContent className={classes.dialogContent}>
                        <TextField id='addressTitle' autoFocus fullWidth label="Address Title"/>
                        <Autocomplete className="addressInput"
                                      fields={['address_components', 'formatted_address', 'place_id']}
                                      id="example-autocomplete-id"
                                      onPlaceChanged={(place) => this.addPendingAddress(place)}
                                      types={['address']}
                        />
                        <Typography id='zipCodeError' variant='subtitle2' color='error'
                                    style={{ visibility: 'hidden' }}>
                            The address you entered is not available for service attendance in this moment. Zip code: {this.state.currentZipCode}
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.useOnce.bind(this)}
                                disabled={this.state.pendingAddAddress === undefined || this.state.adding === true}
                                fullWidth variant="outline" color="primary">
                            Use Once
                            <CircularProgress id='useOnceProgress' color='secondary'
                                              style={{ marginLeft: '10px', display: 'none' }} size={20}/>
                        </Button>
                        <Button onClick={this.addAddress.bind(this)}
                                disabled={this.state.pendingAddAddress === undefined || this.state.adding === true}
                                fullWidth variant="contained" color="secondary">
                            Save
                            <CircularProgress id='saveProgress'
                                              style={{ marginLeft: '10px', display: 'none' }} size={20}/>
                        </Button>
                    </DialogActions>
                </Dialog>

                <Adaptable as={SectionTitleContainer} hideFromSmallDown>
                    <SectionTitle>Select Address</SectionTitle>
                    <SectionRight onClick={() => this.setState({ addAddressDialogOpen: true })}
                                  color='secondary'
                                  underline='hover'>
                        ADD ADDRESS
                    </SectionRight>
                </Adaptable>

                <If condition={this.state.loading}
                    as={Loading} style={{marginTop: 20}}>
                    <Progress/><LoadingText>{this.state.loadingText}</LoadingText>
                </If>

                {(this.props.addresses.length === 0 && !this.state.loading) ?
                    (
                        <div style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                            <Typography className={classes.emptyTypography} variant='subtitle1' align="center">
                                Please add the address where our technician should go
                            </Typography>
                        </div>
                    )
                    :
                    (
                        <div className={classes.addressList}>
                            {this.props.addresses.map((address, index) => (
                                <div key={address.id} className={classes.itemDiv} id='itemDiv'
                                     onClick={this.check.bind(this, address)}
                                     style={{ marginBottom: (index < this.props.addresses.length - 1) && '2px' }}>

                                    <Radio onClick={this.check.bind(this, address)} color='primary'
                                           checked={this.isChecked(address)} tabIndex={-1} disableRipple/>
                                    <div style={{
                                        display: 'flex',
                                        flexGrow: 1,
                                        alignSelf: 'center',
                                        flexDirection: 'column',
                                        width: 0/*Solve an issue with the width when shorts resolutions*/
                                    }}>
                                        <Typography>
                                            {address.title}
                                        </Typography>
                                        <Typography>
                                            {address.address.address_line1 + ', ' + address.address.locality + ', ' + address.address.administrative_area}
                                        </Typography>
                                    </div>
                                    <span className={classes.buttonCard}>
                                            <IconButton onClick={this.onDelete.bind(this, address.id)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" height="18" width="18"
                                                     viewBox="0 0 18 18">
                                                    <g>
                                                        <path id="path1"
                                                              transform="rotate(0,9,9) translate(2.25000563263423,0) scale(0.562499530613814,0.562499530613814)  "
                                                              fill="#000000"
                                                              d="M15.000001,8.0000272L17,8.0000272 17,27.000028 15.000001,27.000028z M11.000001,8.0000272L13.000001,8.0000272 13.000001,27.000028 11.000001,27.000028z M7.0000005,8.0000272L9.000001,8.0000272 9.000001,27.000028 7.0000005,27.000028z M3.0790101,5.0000274L4.9959994,29.922999 19.000006,30.000026 20.918949,5.0000274z M13.771989,1.9959999L10.198989,2.0000001C10.158989,2.025,9.9989892,2.241,9.9989892,2.6000001L9.9989892,3.0000258 13.998989,3.0000258 13.998989,2.6000001C13.998989,2.241,13.838988,2.025,13.771989,1.9959999z M10.198989,0L13.798988,0C15.031989,0,15.998989,1.142,15.998989,2.6000001L15.998989,3.0000258 23.07898,3.0000258 24,3.0000272 24,5.0000274 22.925121,5.0000274 20.995976,30.076991C20.999027,31.102992,20.100956,32.000026,18.999029,32.000026L4.9990512,32.000026C3.8960255,32.000026,2.9990543,31.102992,2.999054,30.000026L1.073059,5.0000274 0,5.0000274 0,3.0000272 0.91897895,3.0000272 7.9989887,3.0000258 7.9989887,2.6000001C7.9989887,1.142,8.9659892,0,10.198989,0z"/>
                                                    </g>
                                                </svg>

                                            </IconButton>
                                        </span>
                                </div>
                            ))}
                        </div>
                    )
                }
                <Notification open={this.state.snackBarOpen}
                              type={SUCCESS_TYPE}
                              ActionButton={
                                  <NActionButton key="close" ariaLabel="close"
                                                 onClick={() => this.setState({snackBarOpen: false})}>
                                      <Close/>
                                  </NActionButton>}
                              onClose={() => this.setState({snackBarOpen: false})}>
                    {this.state.snackBarText}
                </Notification>

                <Fab onClick={() => this.setState({ addAddressDialogOpen: true })}
                     size='small' color='secondary'
                     className={classes.addDialogFabButton}>
                    <Add/>
                </Fab>

            </div>
        )
    }

    loadAddress(showDialog = true) {
        if (showDialog === true)
            this.setState({ loading: true, loadingText: loadingMsg });
        APIService.getAddressList()
            .then(response => {
                this.props.actions.receiveUserAddresses(response);
            })
            .catch(console.error)
            .finally(() => {
                if (showDialog === true)
                    this.setState({ loading: false, loadingText: '' });
            })
    }
}

const mapStateToProps = state => {
    return {
        addresses: state.user_addresses,
        zipCodes: state.zip_codes,
        appointmentData: state.appointmentData
    }
};

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({
            receiveAppointmentAddress: receive_appointment_address,
            receiveUserAddresses: receive_user_addresses,
            receiveZipCodes: receive_zip_codes,
            removeAddress: remove_address,
            pushAddress: push_address
        }, dispatch)
    }
};

const AddressStepStyled = withStyles(styles)(AddressStep);
export default connect(mapStateToProps, mapDispatchToProps)(errorBundaryHOC(AddressStepStyled))
